<template>
    <div class="row" style="margin-top: 10px;">
        <div class="col-12">
            <div class="form-group" style="width: 100%;">
                <label :for="item.key">{{ item.label }}</label>
                <input :id="item.key" :name="item.key" :placeholder="item.label" type="text" v-model="itemValue" class="form-control" autocomplete="off">
            </div>
        </div>
    </div>
</template>
<script>
    import EventBus from '../../../../EventBus'

    export default {
        props: [
            'item',
            'restaurant'
        ],

        data () {
            return {
                itemValue: null
            }
        },

        watch: {
            itemValue: function(newValue, oldValue) {
                EventBus.$emit('serviceTypeFormValueUpdated', {
                    key: this.item.key,
                    value: this.itemValue
                });
            }
        },
    }
</script>
